import React, {useEffect, useState} from 'react';
import {PageTitle, SelectText} from "../../_components";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useAuth} from "../../../context";
import {useGetJson, usePostJson} from "../../../hooks";
import {endpoints} from "../../../utils2";
import {WhiteCard} from "../_components/WhiteCard";
import {Formik, Form as FormikForm, Field} from "formik";
import * as yup from "yup";
import {Alert, Button, Dropdown, InputGroup, Stack, Form, Row, Col} from "react-bootstrap";
import {ABBreadcrumbs} from "../_components/ABBreadcrumbs";

export function NtpConfiguration() {
    const {uid, did} = useParams()
    const {authToken} = useAuth()
    const navigate = useNavigate();

    const [dev, loadingDevice, errorDevice, clearErrorDevice] = useGetJson(endpoints.device.get(uid, did), authToken?.jwt)
    const device = dev?.data

    const [sendData, v, postLoading, postError, clearPostError] = usePostJson(endpoints.device.edit(uid, did), authToken?.jwt)

    const ntpMap = ["time.altrabits.com", "time.nist.gov", "pool.ntp.org"]

    const validationSchema = yup.object().shape({
        // ntp: yup.string().required("NTP is required"),
    })

    const initialValues = {
        ntp: device?.ntp || "time.altrabits.com",
    }

    function handleSubmit(values, action) {
        sendData(values, json => {
            action.setSubmitting(false)
            navigate(-1)
        })
    }


    return <>
        <Alert variant="danger" show={errorDevice} dismissible onClose={clearErrorDevice}>{errorDevice}</Alert>
        <Alert variant="danger" show={postError} dismissible onClose={clearPostError}>{postError}</Alert>

        <ABBreadcrumbs breadcrumbList={[
            {name: "Your devices", shortName: "Devices", to: `/device/${uid}`},
            {name: "Configure Device", shortName: "Configure", to: `/device/${uid}/${did}/config`},
            {name: "NTP"}]}
        />

        <PageTitle title="NTP Configuration">{device?.name}</PageTitle>

        <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={initialValues}
                enableReinitialize={true}>
            {({isSubmitting}) => (
                <FormikForm>
                    <WhiteCard className="mt-4">
                        <div className="text-secondary mb-2">NTP Configuration</div>
                        <Field name="ntp">
                            {({field, form}) => (
                                <ComboBox
                                    optionsMap={ntpMap}
                                    placeholder="Select or enter NTP"
                                    value={field.value}
                                    onChange={val => form.setFieldValue(field.name, val)}
                                />
                            )}
                        </Field>
                    </WhiteCard>


                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <Button as={Link} variant="link" to={-1}>Go back</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>Save</Button>
                        {/*<Button type="submit" variant="primary" disabled>Edit</Button>*/}
                    </Stack>
                </FormikForm>
            )}
        </Formik>
    </>
}

function ComboBox({optionsMap, placeholder, value, onChange}) {

    const handleSelect = (name) => {
        onChange(name);
    };

    return <>
        <div>
            <InputGroup>
                <Form.Control
                    type="text"
                    placeholder={`Enter or select an option` || placeholder}
                    value={value}
                    onChange={(e) => {
                        onChange(e.target.value)
                    }}
                />
                <Dropdown onSelect={handleSelect}>
                    <Dropdown.Toggle variant="outline-secondary">
                        Open NTPs
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {optionsMap.map((item, index) => (
                            <Dropdown.Item key={index} eventKey={item}>
                                {item}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </InputGroup>
        </div>

    </>
}

// function ComboBox({initialMap, placeholder, value, onChange}) {
//
//     const [options, setOptions] = useState(initialMap);
//     const [inputValue, setInputValue] = useState(value);
//
//     useEffect(() => {
//         setInputValue(value || '');
//     }, [value]);
//
//     const handleSelect = (name) => {
//         setInputValue(name);
//         onChange(name);
//     };
//
//     const handleAddOption = () => {
//         if (inputValue && !options.some(o => o.name === inputValue)) {
//             const newOption = {id: options.length + 1, name: inputValue};
//             setOptions([...options, newOption]);
//         }
//         onChange(inputValue)
//     };
//
//     const handleRemove = (idToRemove) => {
//         setOptions(options.filter(o => o.id !== idToRemove));
//         if (options.find(o => o.id === idToRemove)?.name === inputValue) {
//             setInputValue('');
//         }
//     };
//
//
//     return <>
//         <div>
//             <InputGroup>
//                 <Form.Control
//                     type="text"
//                     placeholder={`Enter or select an option` || placeholder}
//                     value={inputValue}
//                     onChange={(e) => {
//                         setInputValue(e.target.value)
//                         onChange(e.target.value)
//                     }}
//                 />
//                 <Dropdown onSelect={handleSelect}>
//                     <Dropdown.Toggle variant="outline-secondary">
//                         Options
//                     </Dropdown.Toggle>
//                     <Dropdown.Menu>
//                         {options.map(item => (
//                             <div key={item.id} className="d-flex p-1 align-items-center">
//                                 <Dropdown.Item eventKey={item.name}>
//                                     {item.name}
//                                 </Dropdown.Item>
//                                 {/*<Button*/}
//                                 {/*    variant="outline-danger"*/}
//                                 {/*    size="sm"*/}
//                                 {/*    onClick={() => handleRemove(item.id)}*/}
//                                 {/*>*/}
//                                 {/*    <i className="bi bi-trash"/>*/}
//                                 {/*</Button>*/}
//                             </div>
//                         ))}
//                     </Dropdown.Menu>
//                 </Dropdown>
//                 {/*<Button variant="primary" onClick={handleAddOption}>*/}
//                 {/*    Add*/}
//                 {/*</Button>*/}
//             </InputGroup>
//         </div>
//
//     </>
// }